export const DND_CARD_TYPE = 'BOARD_CARD';
